import { render, staticRenderFns } from "./signUpInfo.vue?vue&type=template&id=0d0af621&scoped=true&"
import script from "./signUpInfo.vue?vue&type=script&lang=ts&"
export * from "./signUpInfo.vue?vue&type=script&lang=ts&"
import style0 from "./signUpInfo.vue?vue&type=style&index=0&id=0d0af621&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0af621",
  null
  
)

export default component.exports